export default "__VITE_ASSET__$i8tMKVt__"